import { useState, useEffect, useContext } from "react";
import AppContext from "../../context";
import css from "./Master.module.css";
import Card from "../../components/Card/Card";
import backgroundCard from "../../assets/images/backgroundCardGreen.png"
import Popup from "../../components/Popup/Popup";
import { FaEdit } from "react-icons/fa";
import { AddDepartemenEntity, DepartemenEntity } from "../../entities/DepartemenEntity";
import ExcelUtils from "../../utils/excel";
import { AlertEntity } from "../../layouts/Alert/AlertEntity";
import { format } from "date-fns";
import { DepartemenService } from "../../services/departemens";

export default function MasterDepartemen() {
  // ========================================= GLOBAL CONTEXT =========================================  //
  const context = useContext(AppContext);
  const contextAccessToken = context.contextAccessToken;
  const contextShowAlertFunc = context.contextShowAlertFunc;
  const contextShowLoadingFunc = context.contextShowLoadingFunc;
  const stateShowLoading = context.stateShowLoading
  // ========================================= GLOBAL CONTEXT =========================================  //


  // ========================================= STATE VIEW =========================================  //
  // const [excludeFilter, setExcludeFilter] = useState();
  // const [tableDataFilter, setTableDataFilter] = useState({});

  const [tableData, setTableData] = useState<DepartemenEntity[]>([]);

  const [selectedDepartemen, setSelectedDepartemen] = useState<DepartemenEntity | null>(null);
  const [selectedAddDepartemen, setSelectedAddDepartemen] = useState<AddDepartemenEntity | null>(null);

  const [showPopup, setShowPopup] = useState(false);
  const [showImportPopup, setShowImportPopup] = useState(false);
  const [showImportedPopup, setShowImportedPopup] = useState(false);
  const [tableImportedPopup, setTableImportedPopup] = useState<any[]>([]);

  // ========================================= STATE VIEW =========================================  //

  // ========================================= FUNCTIONS =========================================  //
  // ========================================= FUNCTIONS =========================================  //

  const handleAddNew = () => {
    setSelectedAddDepartemen(null);
    setSelectedDepartemen(null);
    setShowPopup(true);
  }

  const handlePopupDetail = (row: DepartemenEntity) => {
    setSelectedDepartemen(row);
    setShowPopup(true)
  }

  const handleSaveAddDepartemen = async () => {
    contextShowLoadingFunc(true);
    try {
      if (selectedAddDepartemen == null || selectedAddDepartemen.departemen == null) {
        throw new Error("departemen invalid")
      }
      const resp = await DepartemenService.AddDepartemen({ departemen: selectedAddDepartemen.departemen });
      await generateData();
      contextShowLoadingFunc(false);
      setSelectedDepartemen(null);
      setSelectedAddDepartemen(null);
      setShowPopup(false);
      contextShowAlertFunc(new AlertEntity({ message: resp.message, level: 1 }));
    } catch (error: any) {
      contextShowAlertFunc(new AlertEntity({ message: error.toString(), level: 3 }));
      contextShowLoadingFunc(false);
    }
  }

  const handleSaveUpdateDepartemen = async () => {
    contextShowLoadingFunc(true);
    try {
      if (selectedDepartemen == null) { throw new Error("departemen invalid") }
      const resp = await DepartemenService.UpdateDepartemen(selectedDepartemen, { departemen: selectedDepartemen.departemen });
      await generateData();
      contextShowLoadingFunc(false);
      setSelectedDepartemen(null);
      setShowPopup(false);
      contextShowAlertFunc(new AlertEntity({ message: resp.message, level: 1 }));
    } catch (error: any) {
      contextShowAlertFunc(new AlertEntity({ message: error.toString(), level: 3 }));
      contextShowLoadingFunc(false);
    }
  }

  const handleDeleteDepartemen = async () => {

    return contextShowAlertFunc(new AlertEntity({
      message: `Apakah anda yakin ingin menghapus ${selectedDepartemen?.departemen} ?`,
      onOk: async () => {
        contextShowLoadingFunc(true);
        try {
          if (selectedDepartemen == null) { throw new Error("departemen invalid") }
          const resp = await DepartemenService.DeleteDepartemen(selectedDepartemen);
          await generateData();
          contextShowLoadingFunc(false);
          setSelectedDepartemen(null);
          setShowPopup(false);
          contextShowAlertFunc(new AlertEntity({ message: resp.message, level: 1 }));
        } catch (error: any) {
          contextShowAlertFunc(new AlertEntity({ message: error.toString(), level: 3 }));
          contextShowLoadingFunc(false);
        }
      },
      withCancel: true,
      withOk: true,
      level: 2
    }))
  }

  const handleGenerateExcel = async () => {
    if (tableData.length == 0) { return contextShowAlertFunc(new AlertEntity({ message: "NO DATA!", level: 3 })); }
    const column = ["departemen"];
    let values: { [key: string]: string }[] = [];
    for (let i = 0; i < tableData.length; i++) {
      values.push({
        departemen: tableData[i].departemen,
      })
    }
    ExcelUtils.export(`Departemen List on ${format(new Date(), "yyyy-MM-dd")}`, column, values);
  }

  const handleSelectExcelFile = async (event: any) => {
    try {
      const file = event.target.files[0];
      let ext = file.name.split('.').pop();
      if (ext.toLowerCase() != 'xlsx') {
        return contextShowAlertFunc(new AlertEntity({ message: `File is not supported!`, level: 3 }));
      }
      const result: any = await ExcelUtils.import(file);
      setShowImportPopup(false);
      setTableImportedPopup(result);
      setShowImportedPopup(true);
    } catch (error: any) {
      return contextShowAlertFunc(new AlertEntity({ message: error.toString(), level: 3 }));
    }
  }

  const importExcel = async () => {
    contextShowLoadingFunc(true);
    try {
      let resp = await DepartemenService.ImportDepartemen(tableImportedPopup);
      await generateData();
      contextShowLoadingFunc(false);
      setShowImportedPopup(false);
      return contextShowAlertFunc(new AlertEntity({ message: resp.message, level: 1 }));
    } catch (error: any) {
      contextShowLoadingFunc(false);
      return contextShowAlertFunc(new AlertEntity({ message: error.toString(), level: 3 }));
    }
  }

  const generateData = async () => {
    contextShowLoadingFunc(true);
    try {
      const resp = await DepartemenService.GetAllDepartemen();
      setTableData(resp);
      contextShowLoadingFunc(false);
    } catch (error: any) {
      contextShowAlertFunc(new AlertEntity({ message: error.toString(), level: 3 }));
      contextShowLoadingFunc(false);
    }
  };

  useEffect(() => {
    generateData();
  }, [contextAccessToken]);

  // ========================================= FUNCTIONS =========================================  //
  // ========================================= FUNCTIONS =========================================  //

  return (
    <>
      <div className="container" style={{ display: stateShowLoading ? "none" : "flex" }}>
        <Card
          detailTitle="Master Departemen"
          detailColor="var(--secondary-color)"
          backgroundImage={backgroundCard}
          stateShow={true}
          detailCard={
            <>
              <div className={css.rowGrid} style={{ alignItems: 'end' }}>
                <div>
                  <div style={{ color: "white", textAlign: "start" }}>Action :</div>
                  <button className="cardButton" onClick={() => handleAddNew()} >
                    Add New
                  </button>
                </div>
                <div>
                  <button className="cardButton" onClick={() => handleGenerateExcel()} >
                    Generate Excel
                  </button>
                </div>
                <div>
                  <button className="cardButton" onClick={() => setShowImportPopup(true)}>
                    Import Excel
                  </button>
                </div>
              </div>
              <div className={css.rowGrid} style={{ alignItems: 'end' }}>
              </div>
            </>
          }
        />
        <div
          style={{
            height: "65vh",
            overflow: "auto"
          }}>
          <table className="tableclickcell">
            {tableData.length > 0 ?
              <>
                <thead>
                  <tr>
                    <th>No</th>
                    <th>Departemen</th>
                    <th>Edit</th>
                  </tr>
                </thead>
                <tbody>
                  {tableData.map((row, idx) => {
                    return <tr key={idx}>
                      <td>{idx + 1}</td>
                      <td>{row.departemen}</td>
                      <td className="group-pick" onClick={() => { handlePopupDetail(row) }}><FaEdit /> Edit</td>
                    </tr>
                  })}
                </tbody>
              </>
              :
              <>
                <thead><tr><th>no data available yet!</th></tr></thead>
              </>
            }
          </table>
        </div>

        {/* Popup Detail */}
        <Popup
          setShowPopup={setShowPopup}
          showPopup={showPopup}
          popupTitle={selectedDepartemen == null ? "Add New" : `Edit ${selectedDepartemen?.departemen}`}
          popupContent={
            selectedDepartemen == null ?
              <>
                <div className={css.form}>
                  <div className={css.containerleftright}>
                    <div className={css.leftposition}>
                      <div className={css.label}> Departemen <span style={{ color: "red" }}>*</span></div>
                      <input className={css.inputedit} type="text" value={selectedAddDepartemen?.departemen ?? ""}
                        onChange={(event) => {
                          setSelectedAddDepartemen((prevState: AddDepartemenEntity | null) => {
                            return new AddDepartemenEntity({
                              ...prevState,
                              departemen: event.target.value
                            })
                          });
                        }}
                      />
                    </div>
                  </div>
                  <div className={css.buttons2}>
                    <div className={css.left}>
                      <button className="tertiaryButton" onClick={() => { setShowPopup(false) }} >
                        Close
                      </button>
                    </div>
                    <div className={css.right}>
                      <button className="primaryButton"
                        onClick={() => { handleSaveAddDepartemen() }} >
                        Save
                      </button>
                    </div>
                  </div>
                </div>
              </>
              : <>
                <div className={css.form}>
                  <div className={css.containerleftright}>
                    <div className={css.leftposition}>
                      <div className={css.label}> Departemen <span style={{ color: "red" }}>*</span></div>
                      <input className={css.inputedit} type="text" value={selectedDepartemen?.departemen ?? ""}
                        onChange={(event) => {
                          setSelectedDepartemen((prevState: DepartemenEntity | null) => {
                            if (prevState == null) {
                              return null;
                            } else {
                              return new DepartemenEntity({
                                ...prevState,
                                departemen: event.target.value
                              })
                            }
                          });
                        }}
                      />
                    </div>
                  </div>
                  <div className={css.buttons2}>
                    <div className={css.left}>
                      <button className="tertiaryButton" onClick={() => { setShowPopup(false) }} >
                        Close
                      </button>
                    </div>
                    <div className={css.right}>
                      <button className="secondaryButton" onClick={() => handleDeleteDepartemen()}>
                        Delete
                      </button>
                    </div>
                    <div className={css.right}>
                      <button className="primaryButton"
                        onClick={() => { handleSaveUpdateDepartemen() }} >
                        Save
                      </button>
                    </div>
                  </div>
                </div>
              </>
          }
        />

        {/* Popup Import */}
        <Popup
          setShowPopup={setShowImportPopup}
          showPopup={showImportPopup}
          popupTitle={"Import File"}
          popupContent={
            <>
              <div style={{ maxWidth: '1200px' }}>
                <label>File Name:</label>
                <input type="file" onChange={(event) => handleSelectExcelFile(event)} />
                <br />
                <br />
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    columnGap: "2vw",
                  }}
                >
                  <div>Notes : Pakai Template Seperti hasil dari Generate Excel <span style={{ color: "red" }}>*</span></div>
                </div>
              </div>
            </>
          }
        />

        {/* Popup Imported */}
        <Popup
          setShowPopup={setShowImportedPopup}
          showPopup={showImportedPopup}
          popupTitle={"Imported"}
          popupContent={
            <>
              <div style={{
                maxHeight: "70vh",
                overflow: "auto"
              }}>
                <table className="tablepopup">
                  <thead>
                    <tr key={`tableImportedPopupHeader`}>
                      {tableImportedPopup.length > 0 && Object.keys(tableImportedPopup[0]).map((key) => {
                        return <td key={`tableImportedPopupHeader${key}`}>
                          {(key)}
                        </td>
                      })}
                    </tr>
                  </thead>

                  <tbody>
                    {tableImportedPopup.length > 0 && tableImportedPopup.map((data: any, index) => {
                      return <tr key={`tableImportedPopup-${index}`}>
                        {Object.keys(data).map((key) => {
                          return <td key={`tableImportedPopup${key}-${index}`}>
                            {(data[key])}
                          </td>
                        })}
                      </tr>
                    })}
                  </tbody>
                </table>
              </div>
              <div style={{ display: "flex", flexDirection: "row", justifyContent: "end", alignItems: "end" }}>
                <button className="primaryButton" onClick={() => importExcel()}>
                  Save
                </button>
              </div>
            </>
          }
        />
      </div>
    </>
  );
}
